import { GeofenceAlertReportOutputData } from './geofence-alert-report-output-data.model';


export class GeofenceAlertReportOutput implements IGeofenceAlertReportOutput {
    status!: number;
    message!: string;
    data!: GeofenceAlertReportOutputData;

    constructor(data?: IGeofenceAlertReportOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? GeofenceAlertReportOutputData.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GeofenceAlertReportOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GeofenceAlertReportOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGeofenceAlertReportOutput {
    status: number;
    message: string;
    data: GeofenceAlertReportOutputData;
}

